import { cn } from "./cn";

interface ToggleProps {
  on: boolean;
  onChange?: (next: boolean) => void;
  label?: string;
  sub?: string;
  disabled?: boolean;
}

export function Toggle({ on, onChange, label, sub, disabled }: ToggleProps) {
  return (
    <label className={cn("flex items-center gap-3", disabled && "opacity-50")}>
      {(label || sub) && (
        <div className="flex-1 min-w-0">
          {label && <div className="text-[13.5px] font-semibold">{label}</div>}
          {sub && <div className="text-xs text-sub mt-[2px]">{sub}</div>}
        </div>
      )}
      <button
        type="button"
        role="switch"
        aria-checked={on}
        disabled={disabled}
        onClick={() => onChange?.(!on)}
        className={cn(
          "relative h-[22px] w-[38px] rounded-full transition-colors duration-150 shrink-0",
          on ? "bg-accent" : "bg-line-strong",
        )}
      >
        <span
          className="absolute top-[2px] h-[18px] w-[18px] rounded-full bg-white shadow transition-all duration-150"
          style={{ left: on ? 18 : 2 }}
        />
      </button>
    </label>
  );
}
